import { render, staticRenderFns } from "./unit-access-list-link.vue?vue&type=template&id=32e77128&"
import script from "./unit-access-list-link.vue?vue&type=script&lang=js&"
export * from "./unit-access-list-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports